<template>
  <div>
    <div class="atm-desktop-max-width mobile d-flex flex-column mx-auto">
      <div class="d-flex flex-wrap justify-content-center align-items-center">
        <p class="text-muted m-0 w-100">
          Manage the coins the student will earn.
        </p>
        <button
          class="bg-main mr-2 text-light text-right rounded-pill px-3 py-1 ml-auto small"
          @click="resetDefaults"
        >
          Reset default coins
        </button>
      </div>
      <hr class="my-4 w-100" />
      <b-form @submit.prevent="updateCoinsValues" class="d-flex gap-4 flex-column w-100">
        <div
          v-for="(coinstValue, index) in coinsValues"
          :key="index"
          class="d-flex gap-3 mb-3 flex-wrap w-100"
        >
          <b class="text-uppercase m-0 w-100" v-if="coinstValue.module"
            >{{ coinstValue.module.name }}
          </b>

          <div
            v-for="coinstItem in coinstValue.items"
            :key="coinstItem.id"
            class="d-flex gap-4 justify-content-between align-items-center w-100 flex-wrap"
          >
            <label class="text-secondary m-0">{{ coinstItem.title }}</label>
            <div class="coins-update d-flex gap-2 align-items-center atm-shadow py-0">
              <div class="coin-container">
                <img class="coins-image" :src="require(`@/assets/coin.png`)" />
              </div>
              <input type="number" v-model="coinstItem.value" class="input-coin" required />
            </div>
          </div>
        </div>
        <b-button
          type="submit"
          class="atm-button bg-main mx-auto my-4 w-50"
          :disabled="requestSent"
        >
          <b-spinner v-if="requestSent" label="Save" />
          <span v-else>Save</span>
        </b-button>
      </b-form>
    </div>
  </div>
</template>

<script>
import { useSessionStore } from '@/common';
import notificationToastMixin from '@/Mixins/notificationToast.mixin';

export default {
  props: {
    coinsValues: {
      type: Array,
      required: true,
    },
  },
  data() {
    const sessionStore = useSessionStore();
    return {
      sessionStore,
      requestSent: false,
    };
  },
  computed: {
    getChildId() {
      return this.sessionStore.childSelectedId;
    },
    childSelectedName() {
      return this.sessionStore.childName;
    },
    parentCanEdit() {
      return this.sessionStore.getCurrentChild.parentCanEdit;
    },
  },
  mixins: [notificationToastMixin],
  methods: {
    resetDefaults() {
      if (!this.parentCanEdit) {
        this.readOnlyUserNotificationToast();
        return;
      }
      for (const index in this.coinsValues) {
        const coinValue = this.coinsValues[index].items;
        coinValue.map((coins) => {
          coins.value = coins.defaultValue;
        });
      }
    },
    updateCoinsValues() {
      const coinsToUpdate = [];
      if (!this.parentCanEdit) {
        this.readOnlyUserNotificationToast();
        return;
      }
      for (const value of Object.values(this.coinsValues)) {
        coinsToUpdate.push(
          ...value.items.map((coins) => ({
            code: coins.id,
            value: coins.value,
          })),
        );
      }
      this.$emit('updateCoinsValues', { coinsToUpdate });
      this.requestSent = true;
    },
  },
};
</script>

<style lang="scss">
.input-coin {
  background-color: transparent;
  border: none;
  width: 40px;
}

.coin-container {
  position: relative;
  width: 34px;
  height: 34px;
  padding: 6px;
}
.coins-image {
  position: relative;
  top: -2px;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.coins-update {
  border-radius: 8px;
}
</style>
